<template>
  <tr
  v-if="vmode === 0"
  :class="{'selected': selected[item.tempID]}">

    <td class="sticky">
      <div class="c-flex align-center">
        <v-icon 
        @click.stop="$emit('checkRow', item)"
        :color="selected[item.tempID] ? 'color1' : ''"> 
          {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
        </v-icon>
        <img class="c-align-self-start" src="@/assets/img/illustrations/sugar-and-cinnamon.png" alt="cardboard box" width="46px">
        <span class="ml-3">
        {{ item.definition.name }}
        </span>
      </div>
    </td>
    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue.sync="item.quantity"
      :prefferedSid="prefferedSid"
      class="borderless"
      ></c-ms-ii>
    </td>
  </tr>

  <!-- MOBILE -->
    <v-layout 
    v-else
    class="mrow">
      <v-flex xs8 class="align-center c-flex-r flex-cell">
        <v-icon class="drag-handle" color="">menu</v-icon>
        <v-btn
        icon flat
        @click.stop="$emit('checkRow', item)"
        class="ma-0"
        :color="selected[item.tempID] ? 'color1' : ''">
          <v-icon> 
            {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
        <div>
          {{ item.name }}
        </div>
      </v-flex>
      <v-flex xs4 class="flex-cell">
        <c-ms-ii
        :metric_definition="item.definition" 
        :realValue.sync="item.quantity"
        :prefferedSid="prefferedSid"
        class="borderless"
        ></c-ms-ii>
      </v-flex>
    </v-layout>
</template>

<script>
export default {
  props: ['item', 'vmode', 'selected', 'prefferedSid'],
  data () {
    return {
      // 8
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss">
.drag-handle {
  cursor: move;
}
.mrow {
  cursor: pointer;
  position: relative;
  min-height: 60px;
  border-bottom: 1px solid var(--v-hline-base);

  &:hover {
    background: #fafbfc;
  }
}
.flex-cell {
  padding: 5px;
  border-right: 1px solid var(--v-hline-base);
  display:flex;
  align-items: center;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
